import { renderHTML } from "./htmlToText";

const highlightWiseMate = (
  text: string,
  className: string,
  highlightFirstOnly = false
): JSX.Element[] => {
  const parts = text.split(/(WiseMate)/g);
  let highlighted = false;

  return parts.map((part, index) => {
    if (part === "WiseMate") {
      if (!highlighted || !highlightFirstOnly) {
        highlighted = true;
        return (
          <span key={index} className={`text-primary-200 ${className}`}>
            {part}
          </span>
        );
      }
    }
    return <span key={index}>{renderHTML(part)}</span>;
  });
};

export default highlightWiseMate;
